import { ACCESS_TOKEN, API_BASE_URL } from "../constatns";

const request = (options) => {
	const headers = new Headers({
		'Content-Type': 'application/json',
	});

	if(localStorage.getItem(ACCESS_TOKEN)) {
		headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
	}

	const defaults = {headers: headers};
	options = Object.assign({}, defaults, options);

	return fetch(options.url, options)
	.then(response =>
		response.json().then(json => {
			if(!response.ok) {
				return Promise.reject(json);
			}
			return json;
		})
	);
};

export function getCurrentUser() {

	if(!localStorage.getItem(ACCESS_TOKEN)) {
		return Promise.reject("No access token set.");
	}

	return request({
		url: API_BASE_URL + "/user/infoByEmail?email="+localStorage.getItem("__EM__"),
		method: 'GET'
	});
}

export function login(loginRequest) {
	// return request({
	// 	url: AUTH_URL + "/oauth2/login",
	// 	method: 'POST',
	// 	body: JSON.stringify(loginRequest)
	// });
	return request({
		url: API_BASE_URL + "/login",
		method: 'POST',
		body: JSON.stringify(loginRequest)
	});
}
